// store/index.js
import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import device from './modules/device'
import scrollPosition from './modules/scrollPosition'

Vue.use(Vuex)
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
})
const store = new Vuex.Store({
  state: {
    language: 'cn',
    theme: 'light', //主题
    themeBtn: 'light', //主题按钮选中
    userInfo: {},
    isLogin: 0,
    isapp: 1,
    // 下载
    showDownloadFile: false, //文件下载
    getDownloadFile: function () {},
    iamvip: 0,
    surplusNum: 0, //当前下载文件数量
    showJmUploadlayer: false,
    showuploadlayer: false,
    showPressionList: false, //解压框
    isDownloadStyles: 1,
    collectTotal:0,//收藏消息总数
    collectPost:0,//收藏文章总数
    collectVideo:0,//收藏视频总数
    UploadFloder: {
      id: 0,
      name: '全部文件',
    },
    JmUploadFloder: {
      id: 0,
      name: '全部文件',
    },
    notesTotal: 0, //所有消息
    msgData: [], //消息头部
    isPage: 1, //展示首页的占位骨架屏，2展示详情页的占位骨架屏
  },
  mutations: {
    setAttr(state, data) {
      state[data.name] = data.val
    },
    getDownloadFile(state, opt) {
      state.getDownloadFile(opt)
    },
  },
  modules: { device, scrollPosition },
  plugins: [vuexLocal.plugin],
})

export default store
